import React, { useEffect, useState, Fragment  } from 'react';
import { useUser } from '../UserContext';
import { useNavigate, Link } from 'react-router-dom';
import './index.css';
import logo from '../../imagens/Sem fundo.png';
import { jsPDF } from "jspdf";
import autoTable from 'jspdf-autotable';

const Cliente = () => {
  const navigate = useNavigate();
  const { userInfo } = useUser();  

  const [loadingClientes, setLoadingClientes] = useState(true); // novo estado
  const [clientes, setClientes] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCliente, setSelectedCliente] = useState(null);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [showModalCadastroCliente, setShowModalCadastroCliente] = useState(false);

  const [showFinanceiroModal, setShowFinanceiroModal] = useState(false);
  const [showPedidoModal, setShowPedidoModal] = useState(false);
  const [expandedClienteId, setExpandedClienteId] = useState(null);
  const [financeiroData, setFinanceiroData] = useState([]);
  const [loadingFinanceiro, setLoadingFinanceiro] = useState(false);
  const [pedidoData, setPedidoData] = useState([]);
  const [loadingPedido, setLoadingPedido] = useState(false);
  const [documento, setDocumento] = useState('');

   // Itens do pedido
  const [itensPedido, setItensPedido] = useState([]);
  const [nfeSelecionada, setNfeSelecionada] = useState(null);
  const [loadingItens, setLoadingItens] = useState(false);

  useEffect(() => {
    if (!userInfo?.username || !userInfo?.company) {
      localStorage.removeItem('userInfo');
      navigate('/home');
    }
  }, [userInfo, navigate]);

  const credentials = btoa(`${userInfo.alias};${userInfo.venLogin}:${userInfo.venSenha}`);
  const atualizaClientes = async () => {
      try {
        setLoadingClientes(true); // começa carregamento

        const res = await fetch(`${userInfo.url}/cliente/WenAPP/vendedor/${userInfo.ven_id}`, {
          headers: {
            'Content-Type': 'application/json',
            'empresa': userInfo.alias,
            'Authorization': `Basic ${credentials}`,
          }
        });

        const text = await res.text();
        const safeText = text.replace(/\u00A0/g, ' ').trim();
        const json = JSON.parse(safeText);
        setClientes(json);
      } catch (err) {
        console.error('Erro ao buscar clientes:', err);
      } finally {
        setLoadingClientes(false); // encerra carregamento
      }
    };

  useEffect(() => {
    const fetchClientes = async () => {
      try {
        setLoadingClientes(true); // começa carregamento

        const res = await fetch(`${userInfo.url}/cliente/WenAPP/vendedor/${userInfo.ven_id}`, {
          headers: {
            'Content-Type': 'application/json',
            'empresa': userInfo.alias,
            'Authorization': `Basic ${credentials}`,
          }
        });

        const text = await res.text();
        const safeText = text.replace(/\u00A0/g, ' ').trim();
        const json = JSON.parse(safeText);
        setClientes(json);
      } catch (err) {
        console.error('Erro ao buscar clientes:', err);
      } finally {
        setLoadingClientes(false); // encerra carregamento
      }
    };

    fetchClientes();
  }, [userInfo, credentials]);
  
  const filteredClientes = clientes.filter((c) => {
    const termo = searchTerm.toLowerCase();

    return (
      c.cliId?.toString().includes(termo) ||                // Código      
      c.colNome?.toLowerCase().includes(termo) ||           // Nome
      c.colFantasia?.toLowerCase().includes(termo) ||           // fantasia
      c.colCnpjCpf?.toLowerCase().includes(termo)
    );
  });

  const handleSelectCliente = (cliente) => {
    setSelectedCliente(cliente);
    setSearchTerm(cliente.colNome);
    setShowSuggestions(false);
  };

  const openModalCadastroCliente = () => {
    setShowModalCadastroCliente(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault(); // Mova o preventDefault para o início

    // 1. Extrair os valores dos campos do formulário
    const form = e.target;
    const formData = {
      COL_NOME: form.COL_NOME?.value.toUpperCase() || '',
      COL_FANTASIA: form.COL_FANTASIA?.value.toUpperCase() || '',
      COL_TIPO_PESSOA: form.COL_TIPO_PESSOA?.value || '',
      COL_CNPJ_CPF: form.COL_CNPJ_CPF?.value || '',
      COL_INSCRICAO_ESTADUAL: form.COL_INSCRICAO_ESTADUAL?.value || '',
      END_RUA: form.END_RUA?.value.toUpperCase() || '',
      END_NUMERO: form.END_NUMERO?.value || '',
      COL_CONTATO: form.COL_CONTATO?.value.toUpperCase() || '',
      COL_FONE1: form.COL_FONE1?.value || '',
      COL_FONE2: form.COL_FONE2?.value || '',
      COL_EMAIL: form.COL_EMAIL?.value || '',
      COL_CELULAR_WHATSAPP: form.COL_CELULAR_WHATSAPP?.value || '',
      END_CEP: form.END_CEP?.value || '',
      END_COMPLEMENTO: form.END_COMPLEMENTO?.value.toUpperCase() || '',
      END_BAIRRO: form.END_BAIRRO?.value.toUpperCase() || '',
      END_CIDADE: form.END_CIDADE?.value.toUpperCase() || '',
      END_ESTADO: form.END_ESTADO?.value || '',
      CLI_TIPO: form.CLI_TIPO?.value || '',
      VEN_ID: userInfo.ven_id || '',
      COL_OBSERVACAO: form.COL_OBSERVACAO?.value || '',
      COL_ATIVO: userInfo.bloqClienteIncompleto === 'T' ? true : false,
    };

    // 2. Realizar as validações usando o objeto formData
    if (userInfo.bloqClienteIncompleto === 'T') {
      if (!formData.COL_NOME) return alert('O campo NOME é obrigatório.');
      if (!formData.COL_FANTASIA) return alert('O campo FANTASIA é obrigatório.');
      if (!formData.COL_TIPO_PESSOA) return alert('O campo TIPO PESSOA é obrigatório.');
      if (!formData.COL_CNPJ_CPF) return alert('O campo CNPJ/CPF é obrigatório.');
      if (!formData.END_RUA) return alert('O campo RUA é obrigatório.');
      if (!formData.END_NUMERO) return alert('O campo NÚMERO é obrigatório.');
      if (!formData.COL_CONTATO) return alert('O campo CONTATO é obrigatório.');
      if (!formData.COL_FONE1) return alert('O campo FONE 1 é obrigatório.');
      if (!formData.COL_EMAIL) return alert('O campo EMAIL é obrigatório.');
      if (!formData.COL_CELULAR_WHATSAPP) return alert('O campo CELULAR/WHATSAPP é obrigatório.');
      if (!formData.END_CEP) return alert('O campo CEP é obrigatório.');
      if (!formData.END_BAIRRO) return alert('O campo BAIRRO é obrigatório.');
      if (!formData.END_CIDADE) return alert('O campo CIDADE é obrigatório.');
      if (!formData.END_ESTADO) return alert('O campo ESTADO é obrigatório.');
    }

    // 3. Enviar para a API
    try {
      const response = await fetch(`${userInfo.url}/cliente`, {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
          'empresa': userInfo.alias,
          'Authorization': `Basic ${credentials}`
        },
        body: JSON.stringify(formData), // Envia o objeto que já validamos
      });

      if (response.ok) {
        alert('Cliente salvo com sucesso! código: ' + (await response.text()));
        setShowModalCadastroCliente(false);
        atualizaClientes();
        // Opcional: recarregar lista de clientes aqui
      } else {
        alert('Erro ao salvar cliente. Tente novamente.');
      }
    } catch (error) {
      console.error('Erro ao salvar cliente:', error);
      alert('Erro ao salvar cliente. Tente novamente.');
    }
  };

  // Função para abrir o modal financeiro e carregar os dados

  const openFinanceiroModal = async (cliente) => {
    setSelectedCliente(cliente);
    setShowFinanceiroModal(true);
    setFinanceiroData([]);
    setLoadingFinanceiro(true);

    try {
      const res = await fetch(`${userInfo.url}/receber/cliente/${cliente.cliId}`, {
        headers: {
          'Content-Type': 'application/json',
          'empresa': userInfo.alias,
          'Authorization': `Basic ${credentials}`,
        }
      });

      const text = await res.text();
      const safeText = text.replace(/\u00A0/g, ' ').trim();
      const json = JSON.parse(safeText);

      setFinanceiroData(json);
    } catch (err) {
      console.error('Erro ao buscar dados financeiros:', err);
    } finally {
      setLoadingFinanceiro(false);
    }
  };

  const openPedidoModal = async (cliente) => {
    setSelectedCliente(cliente);
    setShowPedidoModal(true);
    setPedidoData([]);
    setLoadingPedido(true);

    try {
      const res = await fetch(`${userInfo.url}/nfe`, {
        headers: {
          'Content-Type': 'application/json',
          'empresa': userInfo.alias,
          'Authorization': `Basic ${credentials}`,
          'venId': userInfo.ven_id,
          'cliId': cliente.cliId,
        }
      });

      const text = await res.text();
      const safeText = text.replace(/\u00A0/g, ' ').trim();
      const json = JSON.parse(safeText);

      setPedidoData(json);
    } catch (err) {
      console.error('Erro ao buscar dados financeiros:', err);
    } finally {
      setLoadingPedido(false);
    }
  };

    // Função renomeada para não conflitar com o estado "itensPedido"
  const buscarItensPedido = async (nfeId) => {
    // Se já está aberto, fecha
    if (nfeSelecionada === nfeId) {
      setNfeSelecionada(null);
      setItensPedido([]);
      return;
    }

    setNfeSelecionada(nfeId);
    setItensPedido([]);
    setLoadingItens(true);

    try {
      const res = await fetch(`${userInfo.url}/itemnfe/pedido/${nfeId}`, {
        headers: {
          'Content-Type': 'application/json',
          'empresa': userInfo.alias,
          'Authorization': `Basic ${credentials}`,
        }
      });

      const text = await res.text();
      const safeText = text.replace(/\u00A0/g, ' ').trim();
      const json = JSON.parse(safeText);

      setItensPedido(json);
    } catch (err) {
      console.error('Erro ao buscar itens do Pedido:', err);
    } finally {
      setLoadingItens(false);
    }
  };

  const closeModals = () => {
    setShowFinanceiroModal(false);
    setShowPedidoModal(false);
    setSelectedCliente(null);
    setShowModalCadastroCliente(false);
    setFinanceiroData([]);
    setPedidoData([]);
    setDocumento('');
  };

  const toggleExpand = (id) => {
    setExpandedClienteId(prevId => (prevId === id ? null : id));
  };

  const formatarData = (dataISO) => {
    if (!dataISO) return '';
    const d = new Date(dataISO);
    return d.toLocaleDateString('pt-BR', { timeZone: 'UTC' });
  };

  const imprimirBoleto = async (creId, cliente) => {
      try {

        // 6️⃣ Depois dispara o fetch para gerar o boleto
        await fetch(`${userInfo.url}/receber/boleto/impressao/${creId}`, {
          method: "GET",
          headers: { empresa: userInfo.alias },
        });

        // 1️⃣ Gera a URL do PDF
        const pdfUrl = `${userInfo.url}/pdf/${userInfo.alias}/${cliente.cliId}.pdf`;
        
        // 2️⃣ Fetch do PDF para download com nome personalizado
        const response = await fetch(pdfUrl);
        const blob = await response.blob();
        
        // 3️⃣ Cria URL do blob
        const url = window.URL.createObjectURL(blob);
        
        // 4️⃣ Download com nome personalizado
        const a = document.createElement('a');
        a.href = url;
        const agora = new Date();
        const dataHora = `${agora.getDate().toString().padStart(2, '0')}-${(agora.getMonth() + 1).toString().padStart(2, '0')}-${agora.getFullYear()}-${agora.getHours().toString().padStart(2, '0')}-${agora.getMinutes().toString().padStart(2, '0')}`;
        a.download = `Boleto-${cliente.colFantasia}-${dataHora}.pdf`;
        a.target = '_blank';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        
        // 5️⃣ Limpa a URL do blob
        window.URL.revokeObjectURL(url);
        
        
      } catch (err) {
        console.error(err);
        alert("Erro ao imprimir boleto");
      }
  };

  const totalFinanceiro = financeiroData.reduce((acc, item) => acc + item.creVlrReceber, 0);

  // Funções para gerar PDFs
  const gerarPDFFinanceiro = () => {
    const pdf = new jsPDF();
    pdf.text(`Relatório Financeiro de Clientes Em Aberto` , 50, 10);
    pdf.text(`Cliente: ${selectedCliente?.colNome || 'Cliente'}`, 50, 20);

    const tableColumn = ["Cliente","Pedido", "Título", "Parcela", "Pagamento", "Emissão", "Vencimento", "Valor"];
    const tableRows = financeiroData.map(item => [
      item.cliente,
      item.nfePedido,
      item.creTitulo,
      item.creParcela,
      item.crePagamento,
      formatarData(item.creDtaEmissao),
      formatarData(item.creDtaVencimento),
      `R$ ${item.creVlrReceber.toFixed(2)}`,
    ]);

    autoTable(pdf, {
      head: [tableColumn],
      body: tableRows,
      startY: 25,
      styles: { fontSize: 8 },
      headStyles: { fillColor: [41, 128, 185] },
      theme: 'grid',
    });

    const totalPages = pdf.internal.getNumberOfPages();
    pdf.setPage(totalPages);
    const finalY = pdf.lastAutoTable.finalY || 30;
    const pageWidth = pdf.internal.pageSize.getWidth();
    const totalText = `Total: ${(totalFinanceiro ?? 0).toLocaleString("pt-BR", {style: "currency", currency: "BRL",})}`;
    const textWidth = pdf.getTextWidth(totalText);
    const xPos = pageWidth - textWidth - 14;
    const yPos = finalY + 10;

    pdf.text(totalText, xPos, yPos);
    pdf.save(`Relatório-Financeiro-${selectedCliente?.colNome || 'Cliente'}.pdf`);
  };  
     
  //função consulta cliente
  const consultarCNPJ = async (cnpj) => {
  const cnpjLimpo = cnpj.replace(/\D/g, '');
    if (cnpjLimpo.length !== 14) {
      alert("CNPJ inválido para consulta.");
      return;
    }

    try {
      // Usando JSONP ou um proxy, pois a Receita WS tem restrição de CORS no plano grátis
      const response = await fetch(`https://publica.cnpj.ws/cnpj/${cnpjLimpo}`);
      const data = await response.json();

      if (data.estabelecimento) {
        // Aqui você mapeia os campos que a API devolve para o seu formulário
        const form = document.querySelector('form');
        form.COL_NOME.value = data.razao_social;
        form.COL_FANTASIA.value = data.estabelecimento.nome_fantasia || data.razao_social;
        form.END_RUA.value = data.estabelecimento.logradouro;
        form.END_NUMERO.value = data.estabelecimento.numero;
        form.END_CEP.value = data.estabelecimento.cep;
        form.END_BAIRRO.value = data.estabelecimento.bairro;
        form.END_CIDADE.value = data.estabelecimento.cidade.nome;
        form.END_ESTADO.value = data.estabelecimento.estado.sigla;
      }
    } catch (error) {
      alert("Erro ao consultar CNPJ. Verifique a conexão ou o limite de buscas.");
    }
  };

// 🔹 [Linha 370] Função que aplica a máscara dinamicamente conforme o banco de dados espera
  const aplicarMascara = (valor) => {
    // Remove tudo o que não for número
    const apenasNumeros = valor.replace(/\D/g, '');

    // Se tiver até 11 caracteres, trata como CPF: 000000000-00
    if (apenasNumeros.length <= 11) {
      return apenasNumeros
        .slice(0, 11) // Limita o CPF a 11 dígitos puros
        .replace(/^(\d{9})(\d)/, '$1-$2'); // Adiciona o hífen após o 9º dígito
    } 
    
    // Se tiver mais de 11, trata como CNPJ: 00000000/0000/00
    return apenasNumeros
      .slice(0, 14) // Garante o limite máximo de 14 números para o CNPJ
      .replace(/^(\d{8})(\d)/, '$1/$2') // Adiciona a primeira barra após o 8º dígito
      .replace(/^(\d{8})\/(\d{4})(\d)/, '$1/$2-$3'); // Adiciona a segunda barra após o 12º dígito
  };

  // 🔹 Handler para capturar as mudanças no input
  const handleChangeDocumento = (e) => {
    const valorComMascara = aplicarMascara(e.target.value);
    setDocumento(valorComMascara);
  };

  return (
    <>
      {loadingClientes ? (
        <div className="loading-container" tabIndex={-1}>
          <img src={logo} alt="Logo" className="loading-logo" />
          <p>Carregando clientes...</p>
        </div>
      ) : (
        <>
          <header className="header">
            <img src={`${userInfo.url}/imagens/${userInfo.alias}.bmp`} alt="Logo da empresa" className='logoHeader'></img>
            <h2>Bem-vindo, {userInfo.username}!</h2>
            <h1>Cadatro de Clientes {userInfo.company}</h1>
          </header>

          <div className="top-bar">
            <Link to="/menu" className="link-style">Voltar ao menu</Link>
            <button className='cadastrarCliente' onClick={openModalCadastroCliente}>+</button>
          </div>

          {/* 🔎 Filtro */}
          <div className="cliente-box">
            <input
              type="text"
              placeholder="Pesquisar cliente..."
              value={searchTerm}
              autoFocus={!loadingClientes} // ⬅ só ativa autofocus depois do carregamento
              onChange={(e) => {
                setSearchTerm(e.target.value);
                setShowSuggestions(true);
                setSelectedCliente(null);
              }}
              onFocus={() => setShowSuggestions(true)}
            />

            {searchTerm && (
              <button
                className="btn-limpar"
                onClick={() => {
                  setSearchTerm('');
                  setSelectedCliente(null);
                  setShowSuggestions(false);
                }}
              >
                Limpar
              </button>
            )}

            {showSuggestions && searchTerm && (
              <ul className="cliente-list">
                {filteredClientes.length > 0 ? (
                  filteredClientes.map((c, index) => (
                    <li key={`${c.cliId}-${index}`} onClick={() => handleSelectCliente(c)}>
                      <strong>{c.cliId}</strong> - {c.colNome}
                    </li>
                  ))
                ) : (
                  <li>❌ Nenhum cliente encontrado</li>
                )}
              </ul>
            )}
          </div>

          <div className="legenda">
            <span><strong>Legendas: </strong></span>
            <span>
              <ul>
                <li><i className="fas fa-exclamation-triangle" style={{ color: '#e74343' }}></i> Cliente com pendências financeiras em Vermelho!</li>
                <li><i className="fas fa-exclamation-triangle" style={{ color: 'yellow' }}></i> Cliente Sem Compras a mas de 20 dias em Amarelo!</li>
                <li><i className="fas fa-exclamation-triangle" style={{ color: 'black' }}></i> Cliente Sem Pendências financeiras e Positivado (com vendas amenos de 20 dias) em Preto!</li>
              </ul>
            </span>
          </div>

          {/* 🧾 Lista de Clientes em Blocos */}
          <div className="clientes-container">
            {filteredClientes.map((cliente) => {
              const isExpanded = expandedClienteId === cliente.cliId;

              return (
                <div key={cliente.cliId} className="cliente-card">
                  <div className={cliente.vencido === "T" ? "cabClienteVencido": cliente.diasSemCompras < 21 ? "cabCliente": cliente.diasSemCompras > 20 ? "cabClienteAmarelo" :  "cabCliente"}>
                    <span><strong>ID:</strong> {cliente.cliId}</span>
                    <span><strong>Cliente:</strong> {cliente.colNome}</span>
                    <span><strong>Fantasia:</strong> {cliente.colFantasia}</span>
                    
                    <button
                      className="expand-button"
                      onClick={() => toggleExpand(cliente.cliId)}
                    >
                      {isExpanded ? '−' : '+'}
                    </button>
                  </div>

                  {isExpanded && (
                    <>
                      <span><strong>CNPJ/CPF:</strong> {cliente.colCnpjCpf}</span>
                      <span><strong>Inscrição Estadual:</strong> {cliente.colInscricaoEstadual}</span>
                      <span><strong>Endereço:</strong> {cliente.endRua}, {cliente.endNumero}</span>
                      <span><strong>Complemento:</strong> {cliente.endComplemento}</span>
                      <span><strong>Cidade:</strong> {cliente.endCidade}</span>
                      <span><strong>UF:</strong> {cliente.endEstado}</span>
                      <span><strong>CEP:</strong> {cliente.endCep}</span>
                      <span><strong>Email:</strong> {cliente.colEmail}</span>
                      <span><strong>Contato:</strong> {cliente.colContato}</span>
                      <span><strong>Fone1:</strong> {cliente.colFone1}</span>
                      <span><strong>Fone2:</strong> {cliente.colFone2}</span>
                      <span className="whats-line">
                        <strong>Whats:</strong> {cliente.colCelularWhatsapp}
                        {cliente.colCelularWhatsapp && (
                          <button
                            className="whats"
                            onClick={() => {
                              const celular = cliente.colCelularWhatsapp?.replace(/\D/g, '');
                              if (celular) {
                                const url = `https://wa.me/55${celular}`;
                                window.open(url, '_blank');
                              }
                            }}
                          >
                            <i className="fab fa-whatsapp"></i>
                          </button>
                        )}
                      </span>
                      <span><strong>Forma de Pagamento:</strong> {cliente.pagDescricao}</span>
                      <span><strong>Prazo de Pagamento:</strong> {cliente.prazo}</span>
                      <span><strong>Limite de Crédito:</strong> R$ {(cliente.cliLimiteCredito).toFixed(2)}<strong> - Limite Disponível: R$ {(cliente.limiteDisponivel).toFixed(2)}</strong></span>

                      <div className="card-buttons">
                        <button onClick={() => openFinanceiroModal(cliente)}>📊 Financeiro</button>
                        <button onClick={() => openPedidoModal(cliente)}>🧾 Pedidos</button>
                        <button
                          onClick={() => {
                            const destino = encodeURIComponent(
                              `${cliente.endRua || ''}, ${cliente.endNumero || ''} - ${cliente.endCidade || ''}${cliente.endEstado || ''}`
                            );
                            window.open(`https://www.google.com/maps/dir/?api=1&destination=${destino}`, '_blank');
                          }}
                        >
                          📍 Rota
                        </button>
                      </div>
                    </>
                  )}
                </div>
              );
            })}
          </div>
          
          {/* 📊 Modal Financeiro */}
          {showFinanceiroModal && (
            <div className="modal-cliente">
              <div className="modal-content-cliente">
                <h2>Financeiro - {selectedCliente.colNome}</h2>

                {loadingFinanceiro && <p>Carregando...</p>}

                {!loadingFinanceiro && financeiroData.length > 0 ? (
                  <div>
                    <table className="financeiro-grid">
                      <thead>
                        <tr>
                          <th>Pedido</th>
                          <th>Título</th>
                          <th>Parcela</th>
                          <th>Pagamento</th>
                          <th>Emissão</th>
                          <th>Vencimento</th>
                          <th>Status</th>
                          <th>Valor</th>
                          <th>Boleto</th>
                          <th>Banco</th>
                          <th>🖨️ Boleto</th>
                        </tr>
                      </thead>
                      <tbody>
                        {financeiroData.map((item, idx) => (
                          <tr key={idx}>
                            <td>{item.nfePedido}</td>
                            <td>{item.creTitulo}</td>
                            <td>{item.creParcela}</td>
                            <td>{item.crePagamento}</td>
                            <td>{formatarData(item.creDtaEmissao)}</td>
                            <td>{formatarData(item.creDtaVencimento)}</td>
                            <td>{item.creStatus}</td>
                            <td>R$ {item.creVlrReceber.toFixed(2)}</td>
                            <td>{item.creNumBoleto}</td>
                            <td>{item.banNome}</td>
                            <td>{item.crePagamento === 'BOLETO' && (<button className='impBoleto' onClick={() => imprimirBoleto(item.creId, selectedCliente)}>🧾</button>)}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  
                    <span className='total-financeiro'>Total: <strong>R$ {financeiroData.reduce((acc, item) => acc + item.creVlrReceber, 0).toFixed(2)}</strong></span>
                  </div>
                ) : !loadingFinanceiro && (
                  <p>❌ Nenhum registro encontrado</p>
                )}

                <button onClick={closeModals}>Fechar</button>
                <button className='btnPDF' onClick={gerarPDFFinanceiro}>🖨️ PDF</button>
              </div>
            </div>
          )}

          {/* 🔐 Modal Pedidos */}
          {showPedidoModal && (
            <div className="modal-cliente">
              <div className="modal-content-cliente">
                <h2>Pedidos - {selectedCliente.colNome}</h2>
                {loadingPedido && <p>Carregando...</p>}

                {!loadingPedido && pedidoData.length > 0 ? (
                  <table className="Pedido-grid">
                    <thead>
                      <tr>
                        <th>Pedido</th>
                        <th>Nota</th>
                        <th>Cadastro</th>
                        <th>Emissão</th>
                        <th>Status</th>
                        <th>Total Produtos</th>
                        <th>Total Nota</th>
                        <th>🖨️ Romaneio</th>
                        <th>Itens</th>
                        </tr>
                      </thead>
                        <tbody>
                          {pedidoData.map((item, idx) => (
                            <Fragment key={idx}>
                              {/* Linha principal do pedido */}
                              <tr className={nfeSelecionada === item.nfeId ? 'linha-ativa' : ''}>
                                <td>{item.nfeId}</td>
                                <td>{item.nfeNota}</td>
                                <td>{formatarData(item.nfeDtaCadastro) || ''}</td>
                                <td>{formatarData(item.nfeDtaEmissao) || ''}</td>
                                <td>{item.nfeStatus}</td>
                                <td>{item.nfeTotMercadoria.toLocaleString("pt-BR", { style: "currency", currency: "BRL" })}</td>
                                <td>{item.nfeTotNota.toLocaleString("pt-BR", { style: "currency", currency: "BRL" })}</td>
                                <td><button className='btn-romaneio' title="Imprimir romaneio">🧾</button></td>
                                <td>
                                  <button
                                    className='btn-itens'
                                    title={nfeSelecionada === item.nfeId ? "Fechar itens" : "Ver itens do pedido"}
                                    onClick={() => buscarItensPedido(item.nfeId)}
                                  >
                                    {nfeSelecionada === item.nfeId ? '−' : "+" }
                                  </button>
                                </td>
                              </tr>

                              {/* Linha expandida com os itens, logo abaixo da linha clicada */}
                              {nfeSelecionada === item.nfeId && (
                                <tr className="linha-itens">
                                  <td colSpan={9}>
                                    {loadingItens ? (
                                      <p className="carregando-itens">Carregando itens...</p>
                                    ) : itensPedido.length > 0 ? (
                                      <table className="itens-grid">
                                        <thead>
                                          <tr>
                                            <th>Código</th>
                                            <th>Descrição</th>
                                            <th>Qtde</th>
                                            <th>Vlr. Unit.</th>
                                            <th>Vlr. Total</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {itensPedido.map((item, i) => (
                                            <tr key={i}>
                                              <td>{item.proCodInterno ?? ''}</td>
                                              <td>{item.proDescricao ?? ''}</td>
                                              <td>{item.infeQtdProduto}</td>
                                              <td>{Number(item.infeVlrProduto).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                                              <td>{(Number(item.infeQtdProduto) * Number(item.infeVlrProduto)).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                                            </tr>
                                          ))}
                                        </tbody>
                                      </table>
                                    ) : (
                                      <p className="sem-itens">❌ Nenhum item encontrado</p>
                                    )}
                                  </td>
                                </tr>
                              )}
                            </Fragment>
                          ))}
                        </tbody>
                  </table>
                ) : !loadingPedido && (
                  <p>❌ Nenhum registro encontrado</p>
                )}
                <button onClick={closeModals}>Fechar</button>
              </div>
            </div>
          )} 

          {/* ➕ Modal de Cadastro de Clientes */}
          {userInfo.cadastrarCliente === 'T' && showModalCadastroCliente && (
            <div className="modal-cliente">
              <div className="modal-content-cliente">
                <h2>Cadastro de Clientes</h2>
                <form
                  onSubmit={handleSubmit}
                  style={{ maxHeight: '70vh', overflowY: 'auto' }}
                >
                  <div className="form-grid">
                    <select name='COL_TIPO_PESSOA' placeholder='Tipo Pessoa'>
                      <option value='F'>Física</option>
                      <option value='J'>Jurídica</option>
                    </select>

                    <div style={{ display: 'flex', gap: '5px' }} className='cnpj-cpf-container'>
                      <input 
                        name="COL_CNPJ_CPF" 
                        placeholder="CNPJ/CPF" 
                        id="doc_cliente" 
                        value={documento}          // 🔹 Input controlado pelo React
                        onChange={handleChangeDocumento} // 🔹 Aplica a máscara a cada tecla digitada
                        autoComplete="off"
                        required
                        maxLength={16}             // 🔹 14 números + 2 barras do CNPJ = 16 caracteres no total
                      />
                      <button 
                        type="button" 
                        className='btnConsultaCNPJ'
                        onClick={() => {
                          const docLimpo = documento.replace(/\D/g, '');
                          
                          if (docLimpo.length === 14) {
                            consultarCNPJ(docLimpo); // 🔹 Executa a função declarada no topo do arquivo
                          } else {
                            alert("A consulta automática gratuita só está disponível para CNPJ (14 dígitos).");
                          }
                        }}
                      >
                        🔍
                      </button>
                    </div> 

                    <input name="COL_NOME" placeholder="Nome" required autoComplete="off"
                      style={{ textTransform: 'uppercase' }}
                      onBlur={e => e.target.value = e.target.value.toUpperCase()}
                    />

                    <input name="COL_FANTASIA" placeholder="Fantasia" required autoComplete="off"
                      style={{ textTransform: 'uppercase' }}
                      onBlur={e => e.target.value = e.target.value.toUpperCase()}
                    />
                    
                    <input name="COL_INSCRICAO_ESTADUAL" placeholder="Inscrição Estadual" autoComplete="off" />

                    <input name="COL_CONTATO" placeholder="Contato" autoComplete="off"
                      style={{ textTransform: 'uppercase' }}
                      onBlur={e => e.target.value = e.target.value.toUpperCase()} />

                    <input name="COL_FONE1" placeholder="Fone 1" type='phone' autoComplete="off" />

                    <input name="COL_FONE2" placeholder="Fone 2" type='phone' autoComplete="off"/>

                    <input name="COL_EMAIL" placeholder="Email" type='email' autoComplete="off"/>

                    <input name="COL_CELULAR_WHATSAPP" placeholder="Celular/WhatsApp" type='phone' autoComplete="off"/>

                    <input name="END_CEP" placeholder="CEP" autoComplete="off"
                      onBlur={async (e) => {
                        const cep = e.target.value.replace(/\D/g, '');
                        if (cep.length === 8) {
                          try {
                            const res = await fetch(`https://viacep.com.br/ws/${cep}/json/`);
                            const data = await res.json();
                            if (!data.erro) {
                              e.target.form.END_RUA.value = data.logradouro || '';
                              e.target.form.END_BAIRRO.value = data.bairro || '';
                              e.target.form.END_CIDADE.value = data.localidade || '';
                              e.target.form.END_ESTADO.value = data.uf || '';
                            }
                          } catch {}
                        }
                      }}
                    />
                    <input name="END_RUA" placeholder="Rua" autoComplete="off"
                      style={{ textTransform: 'uppercase' }}
                      onBlur={e => e.target.value = e.target.value.toUpperCase()}/>
                    <input name="END_NUMERO" placeholder="Número" autoComplete="off"/>
                    <input name="END_COMPLEMENTO" placeholder="Complemento" autoComplete="off"
                      style={{ textTransform: 'uppercase' }}
                      onBlur={e => e.target.value = e.target.value.toUpperCase()} />
                    <input name="END_BAIRRO" placeholder="Bairro" autoComplete="off"
                      style={{ textTransform: 'uppercase' }}
                      onBlur={e => e.target.value = e.target.value.toUpperCase()} />
                    <input name="END_CIDADE" placeholder="Cidade" autoComplete="off"
                      style={{ textTransform: 'uppercase' }}
                      onBlur={e => e.target.value = e.target.value.toUpperCase()} />
                    <select name="END_ESTADO" placeholder="Estado">
                      <option value="AC">AC</option>
                      <option value="AL">AL</option>
                      <option value="AM">AM</option>
                      <option value="AP">AP</option>
                      <option value="BA">BA</option>
                      <option value="CE">CE</option>
                      <option value="DF">DF</option>
                      <option value="ES">ES</option>
                      <option value="GO">GO</option>
                      <option value="MA">MA</option>
                      <option value="MG">MG</option>
                      <option value="MS">MS</option>
                      <option value="MT">MT</option>
                      <option value="PA">PA</option>
                      <option value="PB">PB</option>
                      <option value="PE">PE</option>
                      <option value="PI">PI</option>
                      <option value="PR">PR</option>
                      <option value="RJ">RJ</option>
                      <option value="RN">RN</option>
                      <option value="RO">RO</option>
                      <option value="RR">RR</option>
                      <option value="RS">RS</option>
                      <option value="SC">SC</option>
                      <option value="SE">SE</option>
                      <option value="SP">SP</option>
                      <option value="TO">TO</option>
                    </select>
                    <select name="CLI_TIPO" placeholder="Tipo Cliente">
                      <option value="CONSUMIDOR">Consumidor</option>
                      <option value="REVENDA">Revenda</option>
                    </select>
                  </div>
                  <div className='botoesCliente'>
                    <button className="btnCancelar" type="button" onClick={closeModals}>Fechar</button>
                    <button type="submit" className="cadastrarCliente">Salvar</button>
                  </div>
                </form>
              </div>
            </div>
          )}  
        </>
      )}
    </>
  );
};

export default Cliente;